module.exports = __webpack_public_path__ + "static/media/heb (1).8af4f0f0.jpg";